<nz-radio-group [(ngModel)]="appointmentSelectedId" class="tw-w-full" (ngModelChange)="select()" *ngIf="showSelection">
  <div class="card-container-shadow not-shadow mb-sm" *ngFor="let appointment of appointments; index as i">
    <label nz-radio [nzValue]="appointment._id">
      <ng-container *ngTemplateOutlet="tpl, context: {appointment: appointment}"></ng-container>
    </label>
  </div>
</nz-radio-group>

<div class="tw-w-full" *ngIf="!showSelection">
  <div class="card-container-shadow not-shadow mb-sm" *ngFor="let appointment of appointments; index as i">
    <div *ngIf="appointment">
      <ng-container *ngTemplateOutlet="tpl, context: {appointment: appointment}"></ng-container>
    </div>
  </div>
</div>

<ng-template #tpl let-appointment="appointment">
  <p class="text-info-sm opacity-70 d-flex justify-content-between align-items-center width-text">
    {{appointment?.type | getTypeAppointment}}
    <span class="status"
      [class.completed]="appointment.status === appointmentStatus.COMPLETED"
      [class.cancelled]="appointment.status === appointmentStatus.CANCELLED"
      [class.scheduled]="appointment.status === appointmentStatus.SCHEDULED"
      [class.to-reschedule]="appointment.status === appointmentStatus.TO_RESCHEDULE">
      {{ appointment.status | getTranslateEnum:'appointmentStatus' }}
    </span>
  </p>
  <p class="text-info-bold mt-xxs width-text">
    <span>{{ appointment.startDate.date | date:'fullDate' }} - </span>
    <span>
      {{ appointment.startDate.date?.getHours() > 12 ? appointment.startDate.date?.getHours() - 12 : appointment.startDate.date?.getHours()}}:{{
      appointment.startDate.date?.getMinutes() === 0 ? '00' : appointment.startDate.date?.getMinutes() }}
      {{ appointment.startDate.date?.getHours() >= 12 ? ' PM' : ' AM' }}
    </span>
  </p>
</ng-template>
